/* global bootstrap */

export const toasts = {
	init: () => {
		const toastElList = [].slice.call( document.querySelectorAll( '.toast' ) );
		toastElList.map( function( toastEl ) {
			const toast = new bootstrap.Toast( toastEl );
			toast.show();
			return toast;
		} );
	},
};
